<div class="board-tab-tools" data-testid="board-tab-bar">
  <span class="board-tab-summary" data-testid="board-tab-counts" role="status">
    @if (scene()) { {{ objectCount() }} structured objects · {{ frameCount() }} frames } @else if (failed()) { The canvas could not be read. } @else { Loading the board… }
  </span>
  <div class="board-tab-actions">
    <app-button2 class="board-tab-secondary" appearance="secondary" size="sm" data-testid="board-tab-download" ariaLabel="Download board" [disabled]="trashed() || !board()"
      stchPopover stchPopoverTrigger="click" stchPopoverPlacement="bottomRight" [stchPopoverContent]="exportMenuTpl">
      <app-icon name="sapphire-download" [size]="14" />Download
    </app-button2>
    <app-button2 class="board-tab-secondary" appearance="secondary" size="sm" data-testid="board-tab-present" [disabled]="!canPresent()" [attr.title]="canPresent() ? null : 'Add a frame to present'" (click)="present()">
      <app-icon name="presention-chart" [size]="14" />Present
    </app-button2>
    <app-button2 class="board-tab-primary" appearance="primary" size="sm" data-testid="board-tab-open-editor" [disabled]="trashed() || opening()" [attr.aria-busy]="opening() || null" (click)="openEditor.emit()">
      <app-icon name="maximize-4" [size]="14" />Open editor
    </app-button2>
  </div>
</div>
@if (failed()) {
  <div class="board-tab-alert flex items-center gap-3 rounded border border-border p-3 text-sm" role="alert">
    <span>Couldn’t read the board.</span>
    <app-button2 appearance="secondary" size="s" data-testid="board-tab-retry" (click)="reload()">Retry</app-button2>
  </div>
}
@if (scene(); as current) {
  <div class="board-tab-canvas" data-testid="board-tab-canvas" #frame>
    @for (item of [boardId()]; track item) {
      <app-boards-canvas-host [boardUid]="item" [scene]="current" [readonly]="true" [openSources]="true" (bridgeReady)="ready($event)" (canvasChange)="canvasChanged($event)" />
    }
    @if (narrow() && bridgeIsReady()) {
      <!-- Excalidraw draws no zoom control in its mobile layout (below 730px wide, or 500px high). This is ITS OWN control, the markup and class names of its footer and
           ZoomActions (@excalidraw/excalidraw 0.18 dist/dev/index.js:16725-16750 Footer, :12542 ZoomActions, :5846-5930 the three buttons, :935-1030 ToolButton, :9966-10002 Stack),
           inside a `.excalidraw` scope so the engine's own stylesheet styles it (dist/dev/index.css:2754-2800, :5030, :5881). It acts as the engine's own zoom actions do (R10-CX-253). -->
      <div class="excalidraw board-tab-zoom" data-testid="board-tab-zoom">
        <div class="layer-ui__wrapper">
          <footer role="contentinfo" class="layer-ui__wrapper__footer App-menu App-menu_bottom">
            <div class="layer-ui__wrapper__footer-left zen-mode-transition">
              <div class="Stack Stack_vertical" style="--gap: 2">
                <section aria-label="Canvas actions">
                  <div class="Stack Stack_vertical zoom-actions" style="--gap: 1">
                    <div class="Stack Stack_horizontal" style="--gap: 0; align-items: center">
                      <button type="button" class="ToolIcon_type_button ToolIcon_size_medium zoom-out-button zoom-button ToolIcon_type_button--show ToolIcon" data-testid="zoom-out" title="Zoom out" aria-label="Zoom out" [disabled]="!canZoomOut()" (click)="zoomStep(-1)">
                        <div class="ToolIcon__icon" aria-hidden="true" [attr.aria-disabled]="!canZoomOut()">
                          <svg aria-hidden="true" focusable="false" role="img" viewBox="0 0 20 20" width="20" height="20" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M5 10h10" stroke-width="1.25" /></svg>
                        </div>
                      </button>
                      <div class="excalidraw-tooltip-wrapper" style="height: 100%">
                        <button type="button" class="ToolIcon_type_button ToolIcon_size_medium reset-zoom-button zoom-button ToolIcon_type_button--show ToolIcon" data-testid="zoom-reset" title="Reset zoom" aria-label="Reset zoom" (click)="zoomReset()">{{ zoomPercent() }}%</button>
                      </div>
                      <button type="button" class="ToolIcon_type_button ToolIcon_size_medium zoom-in-button zoom-button ToolIcon_type_button--show ToolIcon" data-testid="zoom-in" title="Zoom in" aria-label="Zoom in" [disabled]="!canZoomIn()" (click)="zoomStep(1)">
                        <div class="ToolIcon__icon" aria-hidden="true" [attr.aria-disabled]="!canZoomIn()">
                          <svg aria-hidden="true" focusable="false" role="img" viewBox="0 0 20 20" width="20" height="20" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M10 4.167v11.666M4.167 10h11.666" stroke-width="1.25" /></svg>
                        </div>
                      </button>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </footer>
        </div>
      </div>
    }
  </div>
}
@if (presentFrames(); as frames) {
  <app-boards-present-host [boardId]="boardId()" [title]="title()" [frames]="frames" [startIndex]="0" [render]="renderFrame" (ended)="endPresentation()" />
}

<ng-template #exportMenuTpl>
  @if (board(); as current) {
    <app-context-menu-window class="!gap-0 !p-0">
      <app-board-export-menu [board]="current" />
    </app-context-menu-window>
  }
</ng-template>
